// OneDrive:IgnoreCodeCoverage

import { createSingleEvent, ISingleEventType, ISingleEvent } from '../SingleEventBase';
import { EventFieldType } from '../IEvent';
import { CaughtError, ICaughtErrorSingleSchema } from './CaughtError.event';
import { ResultTypeEnum } from './ResultTypeEnum';
export { ResultTypeEnum };
export interface IQosErrorSingleSchema extends ICaughtErrorSingleSchema {
    /**
     * Qos event name
     */
    name: string;
    /**
     * Qos event result code
     */
    resultCode?: string;
    /**
     * This is the result type enum
     */
    resultType?: ResultTypeEnum;
}

export interface IQosError extends ISingleEvent<IQosErrorSingleSchema> {
    data: IQosErrorSingleSchema;
}

export type QosError = IQosError;

export const QosError: IQosErrorType = createSingleEvent<IQosErrorSingleSchema>({
    eventName: 'QosError,CaughtError,Trace,',
    shortEventName: 'QosError',
    critical: true
}, {
        name: {
            isKey: true,
            type: EventFieldType.String
        },
        resultCode: EventFieldType.String,
        resultType: {
            typeRef: ResultTypeEnum,
            type: EventFieldType.Enum
        }
    }, CaughtError);

export interface IQosErrorType extends ISingleEventType<IQosErrorSingleSchema> {
}
